.wrapper {
  display: flex;
  flex-wrap: wrap;

  :global(.ant-breadcrumb-link div) {
    display: flex;
    align-items: center;
  }
}